module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA0ElEQVR4AWOgDwjchR+5l/a8OqH456IYQsPm06/gJBqqnZAJVApEe9bJIzRgVc0fuWHTajeI6t6pqorRxvhs0MmYe2O/LlDp25MS8TXaQNUoGtBQZF3D5zMyQNWXd0vbZukDleLUwBayrW9mLMQZa5YpasYbAdXh1CARu/rgZlug0u/nxKt71CGKcGqwzp/85KgqUPXTo5JBpbpAaXwa8jqLv52TAqo+tkXWLM0AKIdPw+IlARBHz5qjrBIDkiCgAaj0y1nxnGZNsCheDYMSAADx5a5q51dxxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SB.png
// module id = 1256
// module chunks = 0